<template>
  <Layout>
    <div class="login-wrapper">
      <div class="login-form">
        <div class="header">
          <img
            v-if="
              this.getEntityByDomain &&
              this.getEntityByDomain.logo != '' &&
              this.getEntityByDomain.logo != null
            "
            class="login-logo"
            :src="this.getEntityByDomain.logo"
            width="25%"
          />
          <img
            v-else
            class="login-logo"
            src="@/assets/images/logo-lg.svg"
            alt="visipoint_logo"
            width="25%"
          />
        </div>
        <div class="text-login-form">
          <h3 class="hello-text">Hello there</h3>
          <p class="text-message">Please Login</p>
        </div>

        <b-form @submit.prevent="submitToLogin">
          <div
            class="form-group m-d-gruop"
            :class="{ 'is-invalid': isAuthError }"
          >
            <b-form-input
              id="email"
              v-model.trim="data"
              type="text"
              @input="changeEmailOrPasswordVal"
              required
            />
            <label for="email">Email Address or Phone Number</label>
          </div>

          <div
            class="form-group m-d-gruop"
            :class="{ 'is-invalid': isAuthError }"
          >
            <b-form-input
              id="password"
              v-model.trim="password"
              type="password"
              @input="changeEmailOrPasswordVal"
              required
            />
            <label for="password">Password</label>
          </div>

          <div class="text-center" v-if="isAuthError">
            <span class="error-value"> Login credentials are incorrect </span>
          </div>

          <b-button
            variant="primary"
            type="submit"
            pill
            :disabled="!data || !password || submitted"
            class="submit-btn"
          >
            LogIn<i
              v-if="loadingStatus"
              class="bx bx-loader bx-spin font-size-16 align-middle mr-2"
            ></i>
          </b-button>
        </b-form>
      </div>
    </div>

    <b-modal
      @hide="removeDisableLoginButton"
      id="dashboardInvitationModal"
      scrollable
      class="popover-modal"
      hide-header
      hide-footer
      no-close-on-esc
      ref="dashboardInvitationModal"
    >
      <div class="content-cont">
        <p class="header-title">Dashboard Invitation</p>
        <div class="hint-modal">
          You have been added as a user to the "{{ entityName }}" dashboard. Do
          you want to <b>"Accept"</b> or <b>"Reject"</b> this invitation ?
        </div>
        <!-- action btns  -->
        <hr class="h-line" />
        <div class="action-btns">
          <button
            :disabled="isAcceptedBtn"
            @click="acceptOrRejectInvitation('accept')"
            class="login-accept-btn btn btn-primary"
            size="md"
          >
            Accept
            <i
              v-if="isAcceptedLoader"
              style="margin-inline-start: 5px"
              class="bx bx-loader bx-spin font-size-16 align-middle rounded"
            ></i>
          </button>
          <button
            :disabled="isRejectedBtn"
            @click="acceptOrRejectInvitation('reject')"
            class="btn login-reject-btn"
            type="button"
          >
            Reject
            <i
              v-if="isRejectedLoader"
              style="margin-inline-start: 5px"
              class="bx bx-loader bx-spin font-size-16 align-middle rounded"
            ></i>
          </button>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import Layout from "../../layouts/auth";
import { mapGetters, mapActions } from "vuex";

export default {
  title: "Login",
  components: {
    Layout,
  },
  data() {
    return {
      data: "",
      password: "",
      submitted: false,
      isAcceptedBtn: false,
      isAcceptedLoader: false,
      isRejectedBtn: false,
      isRejectedLoader: false,
      isAuthError: false,
      loader: this.$store ? this.$store.state.layout.loader : {} || {},
      entityName: null,
      entityId: null,
      serverId: process.env.VUE_APP_SERVER_ID,
      regEmail:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  watch: {
    getEntityByDomain(val) {
      if (val) {
        this.entityName = val.name;
        this.entityId = val.id;
      }
    },
    password(pass) {
      this.saveUserPassword(pass);
    },
    getLoginErrorMassage(data) {
      if (
        data &&
        data.message == "The username or password is incorrect" &&
        data.status == "error"
      ) {
        this.isAuthError = true;
        this.submitted = false;
      } else if (data && data.message == "pending" && data.status == "error") {
        this.fetchPassportToken().then(() => {
          this.$bvModal.show("dashboardInvitationModal");
        });
      } else {
        this.submitted = false;
      }
    },
    getDashboardInvitation(data) {
      console.log("data", data);
    },
  },
  computed: {
    ...mapGetters("authfack", [
      "loadingStatus",
      "getEntityByDomain",
      "getLoginErrorMassage",
      "getPassportToken",
    ]),
    ...mapGetters("passport", ["getDashboardInvitation"]),
  },
  methods: {
    ...mapActions("authfack", [
      "onEntityBySubdomain",
      "saveUserPassword",
      "clearStore",
      "login",
      "fetchPassportToken",
    ]),
    ...mapActions("passport", [
      "acceptDashboardInvitation",
      "rejectDashboardInvitation",
    ]),
    submitToLogin() {
      this.submitted = true;
      const { data, password, getEntityByDomain, login } = this;
      login({
        data,
        password,
        entity_id: getEntityByDomain && getEntityByDomain.id,
      });
    },
    changeEmailOrPasswordVal() {
      if (this.isAuthError) {
        this.isAuthError = false;
      }
    },
    async acceptOrRejectInvitation(status) {
      let payload = {};
      let dataType = "";
      this.isAcceptedBtn = true;
      this.isRejectedBtn = true;
      let checkDataIsEmail = this.validateEmail(this.data);
      if (checkDataIsEmail) {
        dataType = "email";
      } else if (!isNaN(this.data)) {
        dataType = "phone";
      }
      payload.entity_id = this.entityId;
      payload.server_id = this.serverId;
      if (dataType == "email") {
        payload.email = this.data;
      } else if (dataType == "phone") {
        payload.phone = this.data;
      }
      if (status == "accept") {
        this.isAcceptedLoader = true;
        const { data, password, getEntityByDomain, login } = this;
        this.submitted = true;
        setTimeout(async () => {
          this.acceptDashboardInvitation(payload).then(() => {
            setTimeout(async () => {
              await login({
                data,
                password,
                entity_id: getEntityByDomain && getEntityByDomain.id,
              });
            }, 1000);
          });
        }, 2000);
        // this.acceptDashboardInvitation(payload).then(()=>{
        //   this.submitted = true;
        //   const { data, password, getEntityByDomain, login } = this;
        //   login({
        //     data,
        //     password,
        //     entity_id: getEntityByDomain && getEntityByDomain.id,
        //   });
        // });
      } else if (status == "reject") {
        this.isRejectedLoader = true;
        await await this.rejectDashboardInvitation(payload).then(() => {
          this.$bvModal.hide("dashboardInvitationModal");
          this.submitted = false;
        });
      }
    },
    validateEmail(email) {
      let isEmailForm = false;
      if (this.regEmail.test(email)) {
        isEmailForm = true;
      }
      return isEmailForm;
    },
    removeDisableLoginButton() {
      this.submitted = false;
    },
  },
  beforeMount() {
    this.clearStore();
  },
  created() {
    this.entityName = this.getEntityByDomain?.name;
    this.entityId = this.getEntityByDomain?.id;
  },
  mounted() {
    const hostname = window.location.hostname;
    this.onEntityBySubdomain({ subdomain: hostname });
  },
};
</script>

<style lang="scss">
div#dashboardInvitationModal {
  div#dashboardInvitationModal___BV_modal_content_ {
    background: #ffffff;
    box-shadow: 0px 1px 40px 3px rgb(0 0 0 / 5%);
    border-radius: 26px;
    width: 580px;
    transform: translate(-50%, 30%);
    position: absolute;
    top: 150px !important;
    inset-inline-start: 50%;
    div#dashboardInvitationModal___BV_modal_body_ {
      padding: 0px !important;

      p.header-title {
        font-weight: 700;
        font-size: 17px;
        line-height: 20px;
        margin: 40px auto 38px 46px;
        color: #000000;
      }
      .hint-modal {
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        margin: 0 46px 40px 46px;
        text-align: center;
        color: #787878;
      }
      .h-line {
        opacity: 0.15;
        background: #707070;
        // width:488px;
        margin: 0px 45px 20px 45px;
      }
      .action-btns {
        margin-bottom: 21px !important;
        .login-accept-btn {
          background: #103f5e;
          border-radius: 16.6275px;
          width: 111px;
          height: 33px;
          justify-content: center;
          color: #ffffff;
          font-weight: 400;
          font-size: 16px;
          align-items: center;
          display: flex;
          line-height: 19px;
          text-align: center;
          margin-inline-end: 31px;
        }
        .login-reject-btn {
          align-items: center;
          display: flex;
          border: 1.5px solid #f46a6a;
          width: 111px;
          height: 33px;
          border-radius: 16.6275px;
          justify-content: center;
          color: #f46a6a;

          font-weight: 400;
          font-size: 16px;
          line-height: 19px;
          text-align: center;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.login-wrapper {
  height: 100vh;
  display: flex;
  // align-items: center;
  // justify-content: center;
  .login-form {
    padding: 40px;
    width: 494px;
    background: #ffffff;
    box-shadow: 0px 1px 40px 3px rgb(0 0 0 / 5%);
    border-radius: 26px;
    // transform: translate(-50%, 30%);
    position: absolute;
    margin-top: 100px !important;
    margin-inline-start: 430px !important;
    // margin: auto !important;
    // top: 50%;
    // inset-inline-start: 50%;
    .header {
      // display: flex;
      text-align: center;
      justify-content: space-between;
      margin-bottom: 35px;
      .login-logo {
        text-align: center !important;
        max-width: 87px !important;
      }
    }
    .text-login-form {
      text-align: center;
      margin-top: 25px !important;
      margin-bottom: 41px !important;
      .hello-text {
        font-weight: 700;
        font-size: 20px;
        line-height: 24px;
        /* identical to box height */
        text-align: center;
        color: #000000;
      }

      .text-message {
        margin-top: 8px;

        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        text-align: center;

        color: rgba(0, 0, 0, 0.28);
      }
    }

    .is-invalid {
      border: 1.5px solid #f46a6a !important;
      border-radius: 4px;
    }

    span.error-value {
      font-weight: 600 !important;
      font-size: 14px !important;
      line-height: 19px !important;
      /* identical to box height, or 136% */
      padding-inline-start: 0px !important;
      letter-spacing: 0.25px !important;
      /* #F46A6A */
      color: #f46a6a !important;
    }
    .submit-btn {
      width: 100%;
      margin-top: 40px;
      height: 44px;
      text-transform: uppercase;

      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      /* identical to box height, or 106% */

      text-align: center;
      letter-spacing: 0.25px;
      text-transform: uppercase;
      color: rgba(255, 255, 255, 0.87);
    }
  }
}
</style>
